import {
  SignalNames,
  ThemeColorPalette,
  ThemeColors,
  ThemeSignalColor,
} from '../../theme';

export const getColorPalette = (name: ThemeColors): ThemeColorPalette => {
  const colorBaseName = [
    SignalNames.includes(name as ThemeSignalColor) ? 'signal--' : '',
    name,
  ].join('');

  return {
    'main': `var(--theme--color--${colorBaseName}--main)`,
    'dark': `var(--theme--color--${colorBaseName}--dark)`,
    'ultra-dark': `var(--theme--color--${colorBaseName}--ultra-dark)`,
    'contrast': `var(--theme--color--${colorBaseName}--contrast)`,
    'light': `var(--theme--color--${colorBaseName}--light)`,
    'ultra-light': `var(--theme--color--${colorBaseName}--ultra-light)`,
  };
};
